import { Injectable, NgModule } from '@angular/core';
import { AbstractSecurityStorage, AuthModule as OidcAuthModule } from 'angular-auth-oidc-client';
import { TranslateModule } from '@ngx-translate/core';
import { oidcConfigProvider } from './auth.config';
import { AUTH_SERVICE_PROVIDER } from './service/auth.service';
import { AuthGuard } from './guard/auth.guard';
import { ExternalConsultationGuard } from './guard/consultation.guard';

@Injectable()
export class LocalStorageSecurityStorage implements AbstractSecurityStorage {
    read(key: string): string | null {
        return localStorage.getItem(key);
    }

    write(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    remove(key: string): void {
        localStorage.removeItem(key);
    }

    clear(): void {
        // Only remove OIDC library keys — preserve app keys like 'bciti-language'
        Object.keys(localStorage)
            .filter((k) => /^\d+$/.test(k) || k.startsWith('oidc'))
            .forEach((k) => localStorage.removeItem(k));
    }
}

@NgModule({
    declarations: [],
    providers: [AuthGuard, ExternalConsultationGuard, AUTH_SERVICE_PROVIDER, { provide: AbstractSecurityStorage, useClass: LocalStorageSecurityStorage }],
    imports: [TranslateModule, OidcAuthModule.forRoot({ loader: oidcConfigProvider })],
    exports: [TranslateModule, OidcAuthModule],
})
export class AuthModule {}
